import React from 'react'
import { Container } from 'semantic-ui-react'

export default function PageHeader({
  title = '',
  description = '',
  image = './images/tree-fallen.jpg',
  backgroundPositionY = '100'
}) {
  return (
    <div
      className="page-header-area"
      style={{
        backgroundImage: `url(${image})`,
        backgroundPositionY: `${backgroundPositionY}%`
      }}>
      <Container>
        <div className="page-header">
          <div className="page-header-text">
            <h1 className="title">{title}</h1>
            {description ? <div>{description}</div> : ''}
            {/* <div className="buttonLinks ">
              <a href="#request-a-free-consultation" className="btn btnDefault">
                Request A Free Consultation
              </a>
            </div> */}
          </div>
        </div>
      </Container>
    </div>
  )
}
